'use client';

import styled, { TColorProp } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';

export type TDocsSize = 'label' | 'paragraph';

interface IContainerProps {
  $size: TDocsSize;
  $color: TColorProp;
}

const getFontWeight = {
  label: 500,
  paragraph: 400,
} as Record<TDocsSize, number>;

export const Container = styled.span<IContainerProps>`
  letter-spacing: ${(18 * -1.5) / 100}px;
  line-height: 32px;
  font-size: 18px;
  font-weight: ${({ $size }) => getFontWeight[$size]};
  color: ${({ theme, $color }) => getThemeColor(theme, $color)};
`;
